import React from 'react';
import moment from 'moment';
import { message } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase';

import { lst_pendiente_pagos } from "../../../common/types/pendientePagoType";
import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import printFormatMock from '../../../common/mock/printFormatMock';
import { FACTURA, LISTA_COMPROBANTES } from '../../../common/types/tipoComprobanteType';

import global from '../../../common/utility/global';
import auth from '../../../common/utility/auth';

import comprobanteService from '../../../service/ventas/comprobanteService';
import clienteService from '../../../service/administracion/clienteService';
import vendedorService from '../../../service/administracion/vendedorService';
import notaVentaService from '../../../service/ventas/notaVentaService';
import empresaService from '../../../service/administracion/empresaService';


import Header from '../../../components/Header';
import Filters from '../ReporteComprobantes/Filters';
import ResultList from '../ReporteComprobantes/ResultList';
import ViewModal from '../ReporteComprobantes/ViewModal';
import ImprimirModal from '../ReporteComprobantes/ImprimirModal';
import ViewVinculadoModal from './ViewVinculadoModal';
import ResultListDetalle from '../ReporteComprobantes/ResultListDetalle';

export default class Index extends PaginationBase {

  _isMounted = false;
  constructor(props) {
    super(props);
    this.props.onSetBreadcrumb();
    this.state = {
      loadingEdit: true,
      loadingNew: false,
      isPendiente: false,
      isPendienteSi: true,
      loadingSource: true,
      saveLoading: false,
      loadingCopy: false,
      clientes: [],
      company: {},
      pendientePago: lst_pendiente_pagos,
      IdPendiente: 2,
      estado: [],
      paginationAll: PAGINATION,
      /*FILTER */
      filter: {
        idTipoComprobante: 0,
        fechaInicioStr: global.fetchCurrentDateStr(true),
        fechaFinStr: global.fetchCurrentDateStr(),
        serie: '',
        documento: '',
        idEstado: 0,
        cliente: "",
        idVendedor: 0,
        serieReferencia: '',
        documentoReferencia: '',
        idTipoReferencia: 0,
        tipoReporte: 0,
        incluirNotaVenta: false,
        ...FILTER
      },
      pagination: PAGINATION,
      visible: false,

      onSetFieldsValue: null,
      onGetFieldValue: null,
      searchProductVisible: false,
      searchProductFormValues: {
        validarStock: false,
        precioUnitInclyIGV: false,
        dataSource: []
      },
      emitirVisible: false,
      emitirFilePdf: undefined,
      imprimirVisible: false,
      imprimirFormValues: {
        file: undefined,
        idComprobante: 0,
        idFormato: 0,
        formatos: printFormatMock.values
      },
      correoFormValues: {
        file: undefined,
        idComprobante: 0,
        idFormato: 0,
        correoCliente: '',
        formatos: printFormatMock.values
      },
      cdrVisible: false,
      selectedItem: {},
      viewVisible: false,
      viewFormValues: {},


      comprobantes: LISTA_COMPROBANTES,
      vendedores: [],
      columnVisible: {
        nombre: 'hide',
        referencia: 'hide',
        cantidad: 'hide',
        unidad: 'hide'

      },
    }
  };


  handleClearFilters = () => {
    var filter = {
      idTipoComprobante: 0,
      fechaInicioStr: global.fetchCurrentDateStr(true),
      fechaFinStr: global.fetchCurrentDateStr(),
      serie: '',
      documento: '',
      idEstado: 0,
      cliente: "",
      idVendedor: 0,
      serieReferencia: '',
      documentoReferencia: '',
      idTipoReferencia: 0,
      tipoReporte: 0,
      incluirNotaVenta: false,
      ...FILTER
    };
    this.setState({ filter });
    this._handlePagination(filter);
  };


  handleKeyUpInput = (e) => {
    e.preventDefault();
    if (e.keyCode === 13) {
      const filter = { ...this.state.filter, ...FILTER };
      this._handlePagination(filter);
    }
  };

  handleView = async (item) => {
    this.setState({ loadingVer: true });
    var response = undefined;
    response = item.nombreTipoComprobante.toUpperCase() == 'NOTA DE VENTA' ?
      await notaVentaService.ver({ id: item.id }) :
      await comprobanteService.ver({ id: item.id });
    if (response !== undefined) {
      //response.flagEmpresaGrifo = auth.user().parametros.filter(m => m.abreviatura === EMPRESA_GRIFO)[0].valor === "1" ? true : false;
      response.flagEmpresaGrifo = false;
      this.setState({
        loadingVer: false,
        viewVisible: true,
        viewFormValues: response
      });
    }
  }


  handleExportPdf = async () => {
    this.setState({ loadingPdf: true });
    var response = undefined;
    if (this.state.filter.tipoReporte == 0) {
      response = await comprobanteService.documentosNotapdf(this.state.filter);
    } else {
      response = await comprobanteService.documentosNotaDetallepdf(this.state.filter);
    }
    this.setState({ loadingPdf: false });
    if (response !== undefined)
      global.dowloadFile(response.data, this.state.filter.tipoReporte == 0 ? "Reporte de documentos.pdf" :
        "Reporte detalle de documentos.pdf");

  }


  handleExportExcel = async () => {
    this.setState({ loadingExcel: true });
    var response = undefined;

    if (this.state.filter.tipoReporte == 0) {
      response = await comprobanteService.documentosNotaExcel(this.state.filter);
    } else {
      response = await comprobanteService.documentosNotaDetalleExcel(this.state.filter);
    }
    this.setState({ loadingExcel: false });
    if (response !== undefined)
      global.dowloadFile(response.data, this.state.filter.tipoReporte == 0 ? "Reporte de documentos.xlsx" : "Reporte detalle de documentos.xlsx");
  }


  handleImprimir = async (item) => {
    debugger
    this.setState({ loadingImprimir: true });
    var file = undefined;
    var response = undefined;
    var idFormato = this.state.company.formatoPrint;


    var isNota = item.nombreTipoComprobante.toUpperCase() == 'NOTA DE VENTA' ? true : false;
    if (idFormato === 1) {
      response = isNota ? await notaVentaService.pdfA4({ id: item.id }) : await comprobanteService.pdfA4({ id: item.id })
      file = window.URL.createObjectURL(response.data);
    }

    if (idFormato === 2) {
      response = isNota ? await notaVentaService.ticket({ id: item.id }) : await comprobanteService.ticket({ id: item.id })

      file = window.URL.createObjectURL(response.data);
    }

    if (idFormato === 3) {
      response = isNota ? await notaVentaService.ticket50({ id: item.id }) : await comprobanteService.ticket50({ id: item.id })

      file = window.URL.createObjectURL(response.data);
    }

    this.setState({
      loadingImprimir: false,
      imprimirVisible: true,
      imprimirFormValues: {
        ...this.state.imprimirFormValues,
        idFormato,
        file,
        idComprobante: item.id
      },
      selectedItem: item
    });
  };

  handleChangeImprimir = async (idFormato) => {
    var file = undefined;
    var response = undefined;
    var isNota = this.state.selectedItem.nombreTipoComprobante.toUpperCase() == 'NOTA DE VENTA' ? true : false;

    if (idFormato === 1) {
      response = isNota ? await notaVentaService.pdfA4({ id: this.state.imprimirFormValues.idComprobante }) :
        await comprobanteService.pdfA4({ id: this.state.imprimirFormValues.idComprobante })
      file = window.URL.createObjectURL(response.data);
    }

    if (idFormato === 2) {
      response = isNota ? await notaVentaService.ticket({ id: this.state.imprimirFormValues.idComprobante }) :
        await comprobanteService.ticket({ id: this.state.imprimirFormValues.idComprobante })

      file = window.URL.createObjectURL(response.data);
    }

    if (idFormato === 3) {
      response = isNota ? await notaVentaService.ticket50({ id: this.state.imprimirFormValues.idComprobante }) :
        await comprobanteService.ticket50({ id: this.state.imprimirFormValues.idComprobante })

      file = window.URL.createObjectURL(response.data);
    }

    this.setState({
      imprimirFormValues: {
        ...this.state.imprimirFormValues,
        idFormato,
        file
      }
    });
  };

  handleVinculadoView = async (item) => {
    this.setState({ loadingCopy: true });
    var response = undefined;
    response = item.nombreTipoComprobante.toUpperCase() == 'NOTA DE VENTA' ?
      await notaVentaService.notaVnetaVinculado({ id: item.id }) :
      await comprobanteService.comprobanteVinculado({ id: item.id });

    if (response !== undefined) {


      this.setState({
        loadingCopy: false,
        correoVisible: true,
        viewFormValues: response,
      });
    }
  }


  handleDownloadPdf = async () => {
    global.downloadFileBlob(this.state.imprimirFormValues.file, this.state.selectedItem.serieDocumentoComprobante + ".pdf");
  };


  handleChange = (property, value) => {

    const filter = { ...this.state.filter, [property]: value };
    if (property === "idTipoComprobante") {
      if (value == 97) {
        filter.incluirNotaVenta = true;
      } else {
        filter.incluirNotaVenta = false;
      }
    }
    if (value != null && value != undefined && value != '' && property == "documentoReferencia") {
      const dataSource = this.state.paginationAll.data.filter(item => {
        return (item.otros + ' - ' + item.ordenCompra)
          .toUpperCase()
          .match(value.toUpperCase());
      });

      this.setState({
        pagination: {
          ...this.state.pagination,
          data: dataSource
        },
        filter
      });
    }
    if (property === "tipoReporte") {
      this._handlePagination(filter);
      this.setState({
        pagination: this.state.paginationAll,
        filter
      });
      return
    }

    else {
      this.setState({
        // pagination: this.state.paginationAll,
        filter
      });
    }

  };

  async componentDidMount() {
    this._isMounted = true;
    const empresa = await empresaService.obtenerPrincipal(0);

    this._initPagination({ ...this.state.filter }, comprobanteService.paginacionComprobante);
    const estado = await comprobanteService.listarEstado();

    const clientes = await clienteService.listar();
    const vendedores = await vendedorService.listar();

    if (this._isMounted) {
      this.setState({
        loadingEdit: false,
        loadingSource: false,
        vendedores: vendedores ? vendedores : [],
        clientes: clientes ? clientes : [],
        estado: estado ? estado : [],
        company: empresa,
        paginationAll: this.state.pagination
      });
    }
  };


  handlePagination = () => {
    this._handlePagination(this.state.filter);

  }
  componentWillUnmount() {
    this._isMounted = false;
  };



  render() {
    return (
      <div>
        <Header
          title="Comprobantes"
          loadingNew={this.state.loadingSource || this.state.loadingNew}
          onSearch={this.handlePagination}
          onClearFilters={this.handleClearFilters}
        />
        <Filters
          filter={this.state.filter}
          clientes={this.state.clientes}
          vendedores={this.state.vendedores}
          comprobantes={this.state.comprobantes}
          onKeyUpSearch={this.handleKeyUpInput}
          onChange={this.handleChange}
          estado={this.state.estado}

        />
        {this.state.filter.tipoReporte == 0 ?
          <ResultList
            pagination={this.state.pagination}
            loadingEdit={this.state.loadingEdit}
            loadingCopy={this.state.loadingCopy}
            loadingVer={this.state.loadingVer}
            loadingExcel={this.state.loadingExcel}
            loadingPdf={this.state.loadingPdf}
            loadingImprimir={this.state.loadingImprimir}
            loadingEmitir={this.state.loadingEmitir}
            loadingCorreo={this.state.loadingCorreo}
            onExportExcel={this.handleExportExcel}
            onExportPdf={this.handleExportPdf}
            onPrint={this.handlePrint}
            onChange={this._handleChangePagination}
            onView={this.handleView}
            onImprimir={this.handleImprimir}
            onVinculado={this.handleVinculadoView}
          /> :
          <ResultListDetalle
            pagination={this.state.pagination}
            loadingEdit={this.state.loadingEdit}
            loadingCopy={this.state.loadingCopy}
            loadingVer={this.state.loadingVer}
            loadingExcel={this.state.loadingExcel}
            loadingPdf={this.state.loadingPdf}
            loadingImprimir={this.state.loadingImprimir}
            loadingEmitir={this.state.loadingEmitir}
            loadingCorreo={this.state.loadingCorreo}
            onExportExcel={this.handleExportExcel}
            onExportPdf={this.handleExportPdf}
            onPrint={this.handlePrint}
            onChange={this._handleChangePagination}
            onView={this.handleView}
            onImprimir={this.handleImprimir}
            onVinculado={this.handleVinculadoView}
          />
        }
        <ImprimirModal
          visible={this.state.imprimirVisible}
          formValues={this.state.imprimirFormValues}
          onChange={this.handleChangeImprimir}
          onDownload={this.handleDownloadPdf}
          onClose={() => this.setState({ imprimirVisible: false })}
        />

        <ViewModal
          visible={this.state.viewVisible}
          formValues={this.state.viewFormValues}
          onClose={() => this.setState({ viewVisible: false })}
        />


        <ViewVinculadoModal
          visible={this.state.correoVisible}
          formValues={this.state.viewFormValues}
          onClose={() => this.setState({ correoVisible: false })}
        />
      </div>
    )
  }
}

